import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';
import { Div, Panel, Typography } from '@icecreamsocial/components';
import { CondensedConversions } from '../../../presentational';
import { useStore } from '../../../../utils/hooks';
import { formatCurrency } from '../../../../utils';
import { useParams } from 'react-router-dom';

const InfluencerConversions = ({
	influencer,
	conversionsGenerated = 0,
	revenueGenerated = 0,
	manageLink,
}) => {
	const store = useStore();
	const { campaignId } = useParams();
	const [focusedConversions, setFocusedConversions] = useState([]);
	const getConversions = async () => {
		if (!influencer || !campaignId) return;
		const conversions = await store.resolveInfluencerConversionsFlow({
			influencerId: influencer.id,
			limit: 5,
			campaignId,
		});
		setFocusedConversions(conversions);
	};

	useEffect(() => {
		if (influencer?.id) {
			getConversions();
		}
	}, [influencer, campaignId]);

	return (
		<Panel backgroundColor='bodyInverse'>
			<Panel.Body>
				<Div
					display='flex'
					alignItems='center'
					justifyContent='space-between'
					marginBottom='lg'
				>
					<Typography.H2 typoWeight='500' mar gin='0'>
						Conversions
					</Typography.H2>
					{!!focusedConversions.length && (
						<Typography.A
							as={Link}
							to={manageLink}
							visitedTextColor='link'
							textColor='link'
							typoWeight='600'
						>
							Manage
						</Typography.A>
					)}
				</Div>
				<Div
					grid
					gridColumns='repeat(2, 1fr)'
					style={{ gap: '16px' }}
					marginBottom='lg'
				>
					<Panel backgroundColor='ambientLight' border='none'>
						<Panel.Body textAlign='center'>
							<Typography.Span
								marginBottom='md'
								typoSize='lg'
								typoWeight='bold'
								display='block'
							>
								{conversionsGenerated}
							</Typography.Span>
							<Typography.Span display='block'>
								Conversions Generated
							</Typography.Span>
						</Panel.Body>
					</Panel>
					<Panel backgroundColor='ambientLight' border='none'>
						<Panel.Body textAlign='center'>
							<Typography.Span
								marginBottom='md'
								typoSize='lg'
								typoWeight='bold'
								display='block'
							>
								{formatCurrency(revenueGenerated, 'en-US', {
									style: 'currency',
									currency: 'USD',
								})}
							</Typography.Span>
							<Typography.Span display='block'>
								Revenue Generated
							</Typography.Span>
						</Panel.Body>
					</Panel>
				</Div>

				<CondensedConversions collection={focusedConversions} />
			</Panel.Body>
		</Panel>
	);
};
InfluencerConversions.displayName = 'InfluencerManager.Conversions';

export default observer(InfluencerConversions);
